export default "__VITE_ASSET__abc40713__"